import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePost } from "@/api/post";
import { toast } from "sonner";

export const useDeletePost = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (postId) => deletePost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["blogs"], refetchType: "all" });
      toast.success("Post deleted successfully");
    },
    onError: () => {
      toast.error("Failed to delete post");
    },
  });
};
